export const StudyIds = {
	ResearcherStudyId: 'e6b3998c-13d9-49fe-a13e-7af27c8229fd'
};
